import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import { validateToken } from '../store/actions/authActions';
import { tokenKey } from '../assets/js/constants';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Wrapper from '../components/layout/Wrapper';
import { theme } from '../components/layout/Style';

const PrivateRoute = ({ component: Component, auth, validateToken, ...rest }) => {
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem(tokenKey))
    if (user && !auth.validToken) {
      validateToken(user.token)
    }
  }, [auth.validToken, validateToken])

  const { user, validToken } = auth

  if (user && validToken) {
    axios.defaults.headers.common['Authorization'] = user.token
    return (
      <Route
        {...rest}
        render={props => (
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Wrapper>
              <Component {...props} />
            </Wrapper>
          </ThemeProvider>
        )}
      />
    )
  } else if (!user && !validToken) {
    return <Redirect to='/login' />
  } else {
    return null // ou um loader
  }
}

const mapStateToProps = state => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({ validateToken }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)